






import { Component, Vue } from 'vue-property-decorator';
import ForgotPasswordForm from '@/components/forgot-password/ForgotPasswordForm.vue';
import PasswordSent from '@/components/forgot-password/PasswordSent.vue';
import { Action } from 'vuex-class';

@Component({
    name: 'ForgotPassword',
    components: {
        ForgotPasswordForm,
        PasswordSent,
    },
})
export default class ForgotPassword extends Vue {
    @Action('user/logoutUser') protected logoutUser!: () => void;

    protected currentActiveComponent = 'ForgotPasswordForm';

    protected onForgetPassword() {
        this.currentActiveComponent = 'PasswordSent';
        this.logoutUser();
    }

}
